import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
/* eslint-disable react/require-default-props */
import DatePicker from 'react-datepicker';
import defaultDatepickerProps from '@widgets/shared/components/form-controls/DatepickerInput/defaultProps';
import { addMonths, format } from 'date-fns';
import useDatepickerConfig from '@widgets/shared/components/CustomDatepicker/hooks/useDatepickerConfig';
import DatesCTX from '@widgets/shared/components/CustomDatepicker/context/dates';
import { useState } from 'react';
import DatepickerHeader from '@widgets/shared/components/CustomDatepicker/components/DatepickerHeader';
import DatepickerDay from '@widgets/shared/components/CustomDatepicker/components/DatepickerDay';
import { DatePickerStyles } from './styles';
const defaultProps = {
    fieldName: 'datepicker',
    fieldValue: new Date(),
};
// Make this actually reusable as the one in BookingForm has a lot of dependencies...
function CustomDatepicker(props = defaultProps) {
    const { fieldName, fieldValue, updateDate } = props;
    const [selectedDate, setSelectedDate] = useState(fieldValue ?? null);
    const { minDate, maxDate, } = useDatepickerConfig({
        formattedAvailableDates: ['2024-01-01'],
        fromDate: format(new Date(), 'yyyy-MM-dd'),
        toDate: format(addMonths(new Date(), 2), 'yyyy-MM-dd'),
    });
    // On Date change
    const handleChange = (newValue) => {
        setSelectedDate(newValue);
        updateDate(newValue);
    };
    return (_jsxs(DatesCTX.Provider, { value: {
            availablePrices: [],
            lowAvailabilityDates: [],
            highAvailabilityDates: [],
            averageAvailabilityDates: [],
            soldOutDates: [],
            selectedDate,
            showAvailability: false,
        }, children: [_jsx("input", { type: "hidden", name: fieldName, value: fieldValue?.toString() }), _jsx("div", { id: "date-wrapper", className: "datepicker-wrappers", children: _jsx(DatePicker, { ...defaultDatepickerProps, name: fieldName ?? '', id: fieldName ?? '', selected: selectedDate, onChange: (date) => (date ? handleChange(date) : false), minDate: minDate, maxDate: maxDate, open: true, monthsShown: 1, renderCustomHeader: ((headerProps) => (_jsx(DatepickerHeader, { ...headerProps }))), renderDayContents: DatepickerDay }) }), _jsx(DatePickerStyles, { id: "date-wrapper" }, "date-wrapper-default-datepicker-styles")] }));
}
export default CustomDatepicker;
